import { createSelector } from 'reselect';
import { IAppState } from '../../../../../AppModulesWrapper';
import { selectPackages } from './selectPackages';
import { IPackage } from '../types';

export const selectActivePackage = createSelector(
  (state: IAppState) => selectPackages(state),
  (packages: IPackage[]): IPackage | null => packages.find(({ selected }) => selected) ?? null,
);
